import type { TargetProgress } from '../../../../../utils/types';

export function getTargetIDsOfAllGoals(targetProgress: TargetProgress[]) {
  return targetProgress.reduce(
    (ids: number[], goal) => [
      ...ids,
      ...goal.target_evaluations.map((evaluation) => evaluation.target_id),
    ],
    [],
  );
}
